module.exports = "/_next/static/images/lead-large-a1e55203a5c305c38e61be36dde882c0.jpg";